(() => {
  if (window.__cloudSearchProductsInit) return;
  window.__cloudSearchProductsInit = true;

  let debounceTimer = null;
  let isMutating = false;

  function isDesktopPanel(root) {
    if (root.classList.contains('cloud-search-results--mobile')) return false;
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getDetailDd(root, dt) {
    const id = dt.getAttribute('data-id');
    if (id) return root.querySelector(`dd[data-id="${id}"]`);
    return dt.nextElementSibling?.matches('dd') ? dt.nextElementSibling : null;
  }

  function getTitleLink(details) {
    return details.querySelector(
      ':scope > a.cs-product-link, :scope > a.cs-item-title, :scope > a[id$="-name"]'
    );
  }

  function clearDesktopProductDetails(details) {
    details.querySelector(':scope > .cs-price-block')?.remove();
    details.querySelector(':scope > .description')?.remove();
  }

  /** Cloud Search preview already renders sale + compare-at; mirror that in list rows only */
  function getPriceMarkupFromDd(dd) {
    const topText = dd?.querySelector('.details-top-text');
    if (!topText) return '';

    return [...topText.children]
      .filter((el) => !el.classList.contains('name'))
      .map((el) => el.outerHTML)
      .join('');
  }

  function ensureListPriceBlock(details, title) {
    let block = details.querySelector(':scope > .cs-price-block');
    if (!block) {
      block = document.createElement('div');
      block.className = 'cs-price-block';
      if (title) details.insertBefore(block, title);
      else details.prepend(block);
    } else if (title && block.nextElementSibling !== title) {
      isMutating = true;
      details.insertBefore(block, title);
      isMutating = false;
    }
    return block;
  }

  function syncListPrice(details, dd) {
    const title = getTitleLink(details);
    const markup = getPriceMarkupFromDd(dd);

    if (!markup) {
      details.querySelector(':scope > .cs-price-block')?.remove();
      return;
    }

    const block = ensureListPriceBlock(details, title);
    if (block.innerHTML === markup) return;

    isMutating = true;
    block.innerHTML = markup;
    isMutating = false;
  }

  function syncProductRow(root, dt) {
    if (!dt.matches('dt.cs-item')) return;

    const details = dt.querySelector('.cs-item-details');
    if (!details) return;

    if (!dt.closest('.results-block.block-products')) {
      clearDesktopProductDetails(details);
      return;
    }

    if (!isDesktopPanel(root)) {
      clearDesktopProductDetails(details);
      return;
    }

    details.querySelector(':scope > .description')?.remove();
    syncListPrice(details, getDetailDd(root, dt));
  }

  function syncProducts(root) {
    if (!isDesktopPanel(root)) {
      root.querySelectorAll('.results-block.block-products dt .cs-item-details').forEach(clearDesktopProductDetails);
      return;
    }

    root.querySelectorAll('.results-block.block-products dt.cs-item').forEach((dt) => syncProductRow(root, dt));
  }

  function scheduleSync(root) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      syncProducts(root);
    }, 50);
  }

  function bind(root) {
    if (!root || root.dataset.productsBound) return;
    root.dataset.productsBound = 'true';
    syncProducts(root);

    const block = root.querySelector('.results-block.block-products') || root;
    new MutationObserver(() => {
      if (isMutating) return;
      scheduleSync(root);
    }).observe(block, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(bind);

    new MutationObserver(() => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach((el) => {
        if (!el.dataset.productsBound) bind(el);
      });
    }).observe(document.body, { childList: true, subtree: true });

    window.matchMedia('(min-width: 750px)').addEventListener('change', () => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(syncProducts);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
